import { CommonModule } from '@angular/common';
import { Component, Injector, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChartData } from 'chart.js';
import { NgChartsModule } from 'ng2-charts';
import { ChartType } from 'src/app/shared/common';
import { LineChart } from 'src/app/shared/model';

import { BaseChartComponent } from '../base-chart-component/base-chart.component';

@Component({
  selector: 'app-line-chart',
  standalone: true,
  imports: [CommonModule, NgChartsModule],
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent extends BaseChartComponent<LineChart> implements OnInit , OnChanges {
  override chartType: ChartType = ChartType.LINE;
  chartData: ChartData<ChartType.LINE, number[] | string[], string | string[]>;
  // constructor
  constructor(injector: Injector) {
    super(injector);
  }

  // hooks
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['data']) {
      this.data = changes['data'].currentValue;
      this.buildChartData();
      this.setChartConfigs();
    }
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  // protected
  protected override buildChartData(): void {
    this.chartData = {
      labels: this.labels,
      datasets: this.data?.map((item) => {
        let dataSetItem: any = {};
        dataSetItem['data'] = [...item["dataSet"]];
        dataSetItem['label'] = item["label"];
        dataSetItem['backgroundColor'] = item['backgroundColor'];
        dataSetItem['borderColor'] = item.borderColor;
        dataSetItem['pointBackgroundColor'] = item.dataSetPointBackgroundColor;
        dataSetItem['pointBorderColor'] = item.dataSetPointBorderColor;
        dataSetItem['pointHoverBackgroundColor'] = item.dataSetPointHoverBackgroundColor;
        dataSetItem['pointHoverBorderColor'] = item.dataSetPointHoverBorderColor;
        dataSetItem['fill'] = 'origin';
        dataSetItem['pointBorderWidth'] = 2
        return dataSetItem;
      }),
    };
  }

  protected override setChartConfigs(): void {
    super.setChartConfigs();
    this.chartOptions = {
      ...this.chartOptions,
      elements: {
        line: {
          tension: 0.5,
        },
      },
      scales: {
        y: {
          position: 'left',
          grace : 5,
          beginAtZero : true,
        },
      },
    };
  }
}
